import { inject, Injectable } from '@angular/core';
import { ApiService, RequestBuilder, RequestTypeEnum } from '@client-monorepo/common/network';
import { Observable, of } from 'rxjs';
import { AnalyticsEventRequest } from '../models/analytics-event-request.interface';
import { LocationRequestInterface } from '../models/location-request.interface';

@Injectable({
  providedIn: 'root',
})
export class EventManagementApiService {
  apiService = inject(ApiService);

  triggerEvent(data: AnalyticsEventRequest[]): Observable<any> {
    try {
      const request = new RequestBuilder(RequestTypeEnum.POST, 'public/event-mng/click', data);
      return this.apiService.call(request);
    } catch (error) {
      return of(null);
    }
  }
  sendLocationData(data: LocationRequestInterface): Observable<any> {
    try {
      const request = new RequestBuilder(RequestTypeEnum.POST, 'public/events/send-event', data);
      return this.apiService.call(request);
    } catch (error) {
      return of(null);
    }
  }
}
